import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class InventoryWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "warehouse", title: "Inventory Home", href: "/inventory" },
            { icon: "numbered list", title: "Quantity Tracked Inventory", href: "/inventory?trackingType=QuantityTracked" },
            { icon: "plus", title: "Add Inventory", href: "/inventory/add" },
            { icon: "plus", title: "Scan Inventory Item", href: "/inventory/scan" },
            {},
            { icon: "th list", title: "Inventory Report", href: "/inventory/report" },
            {},
            { icon: "shopify", title: "Shopify Products", href: "/inventory/shopify" },
            { icon: "globe", title: "Product Customs Info", href: "/inventory/customs" },
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
